<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" :model="initForm" :rules="rules" label-width="120px">
      <el-form-item label="ftp地址" prop="local_url">
        <el-input v-model="initForm.local_url" placeholder="请输入ftp地址"></el-input>
      </el-form-item>

      <el-form-item label="软件包名称" prop="rom_name">
        <el-input v-model="initForm.rom_name" placeholder="请输入软件包名称"></el-input>
      </el-form-item>

      <el-form-item label="软件包版本" prop="version">
        <el-input v-model="initForm.version" placeholder="请输入软件包版本"></el-input>
      </el-form-item>

      <el-form-item label="Dclient版本" prop="dclient_ver">
        <el-input v-model="initForm.dclient_ver" placeholder="请输入Dclient版本"></el-input>
      </el-form-item>

      <el-form-item label="版本类型" prop="release_type">
        <el-select v-model="initForm.release_type" placeholder="选择版本类型">
          <el-option
            v-for="release_type in deviceRomReleaseTypes"
            :label="release_type"
            :key="release_type"
            :value="release_type">
          </el-option>
        </el-select>
        <el-checkbox v-model="initForm.setAsLatest" :disabled="initForm.release_type === '过渡版'" style="margin-left: 10px">设为最新版本</el-checkbox>
      </el-form-item>

      <el-form-item label="存储区域" prop="cloud">
        <el-select disabled v-model="initForm.cloud" placeholder="选择存储区域">
        <el-option
          v-for="item in clouds"
          :label="item.name"
          :key="item.id"
          :value="item.name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="任务状态" prop="status">
        <el-select v-model="initForm.status" placeholder="选择任务状态">
            <el-option
              v-for="status in deviceRomTaskStatus"
              :label="status"
              :key="status"
              :value="status"></el-option>
            </el-select>
      </el-form-item>

      <el-form-item label="下载链接" prop="url">
        <el-input v-model="initForm.url" placeholder="请输入软件包的下载链接"></el-input>
      </el-form-item>

      <el-form-item label="变更记录_英文" prop="change_log_en">
        <el-input type="textarea" :rows="5" v-model="initForm.change_log_en" placeholder="请填写变更记录"></el-input>
      </el-form-item>

      <el-form-item label="变更记录_中文" prop="change_log_cn">
        <el-input type="textarea" :rows="5" v-model="initForm.change_log_cn" placeholder="请填写变更记录"></el-input>
      </el-form-item>

      <el-form-item label="变更记录_日文" prop="change_log_jp">
        <el-input type="textarea" :rows="5" v-model="initForm.change_log_jp" placeholder="请填写变更记录"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { DeviceRomTaskStatus, DeviceRomReleaseTypes } from "@/components/Index/data.js";


export default {
  props: {
    initForm: {},
    updateType: {},
    clouds: {}
  },
  watch: {
    'initForm.release_type': function(newType) {
      // 如果选择过渡版，自动取消勾选"设为最新版本"
      if (newType === '过渡版') {
        this.initForm.setAsLatest = false;
      }
    }
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        local_url: [{required: true, message: "请输入ftp地址", trigger: "blur"}],
        rom_name: [{required: true, message: "请输入软件包名称", trigger: "blur"}],
        version: [{required: true, message: "请输入软件包版本", trigger: "blur"}],
        dclient_ver: [{required: true, message: "请输入Dclient版本", trigger: "blur"}],
        release_type: [{required: true, message: "请选择版本类型", trigger: "blur"}],
        cloud: [{required: true, message: "选择存储区域", trigger: "blur"}],
        status: [{required: true, message: "选择任务状态", trigger: "blur"}]
      },
      titles: {
        add: "新增软件包下载链接",
        edit: "编辑软件包下载链接"
      },
      deviceRomTaskStatus: DeviceRomTaskStatus,
      deviceRomReleaseTypes: DeviceRomReleaseTypes,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              local_url: this.initForm.local_url,
              rom_name: this.initForm.rom_name,
              version: this.initForm.version,
              dclient_ver: this.initForm.dclient_ver,
              cloud: this.initForm.cloud,
              cloud_api_uuid_list: this.initForm.cloud_api_uuid_list,
              url: this.initForm.url,
              change_log_en: this.initForm.change_log_en,
              change_log_cn: this.initForm.change_log_cn,
              change_log_jp: this.initForm.change_log_jp,
              status: DeviceRomTaskStatus.indexOf(this.initForm.status),
              release_type: DeviceRomReleaseTypes.indexOf(this.initForm.release_type),
              set_latest: this.initForm.setAsLatest,
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        // this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-rom/download/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "device-rom/download/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
